const __WEBPACK_NAMESPACE_OBJECT__ = window[Symbol.for('@ally/federator')].modules.get('ally-next-remote-header').externals.get("styled-components");